import { render, staticRenderFns } from "./DidiMinimal.vue?vue&type=template&id=f5b52f5a&scoped=true"
var script = {}
import style0 from "./Didi.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./DidiMinimal.vue?vue&type=style&index=1&id=f5b52f5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b52f5a",
  null
  
)

export default component.exports